import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  InputGroup,
  Badge,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/donordashboard/FindCenters.css";
import MasterLayout from "../../components/layout/MasterLayout";

function FindCenters() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCenter, setSelectedCenter] = useState(null);

  // Sample centers data
  const centers = [
    {
      id: 1,
      name: "Hope Medical Center",
      address: "Model Town, Lahore",
      phone: "+92-300-1234567",
      distance: 5.2,
      isOpen: true,
      type: "Medical",
    },
    {
      id: 2,
      name: "Al-Shifa Donation Center",
      address: "Gulberg, Lahore",
      phone: "+92-300-2345678",
      distance: 3.5,
      isOpen: true,
      type: "Food",
    },
    {
      id: 3,
      name: "Care Foundation",
      address: "DHA Phase 5, Lahore",
      phone: "+92-300-3456789",
      distance: 7.8,
      isOpen: false,
      type: "General",
    },
    {
      id: 4,
      name: "Helping Hands Center",
      address: "Johar Town, Lahore",
      phone: "+92-300-4567890",
      distance: 2.1,
      isOpen: true,
      type: "Blood",
    },
  ];

  const filteredCenters = centers.filter(
    (center) =>
      center.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      center.address.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handleUseMyLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        () => alert("Location detected successfully!"),
        () => alert("Unable to get location."),
      );
    }
  };

  const handleCallNow = (phone) => {
    window.location.href = `tel:${phone}`;
  };

  const handleGetDirections = (center) => {
    alert(`Opening directions to ${center.name}`);
  };

  return (
    <div className="find-centers-page">
      <MasterLayout>
        {/* Header Section */}
        <div className="page-header">
          <Container>
            <h1 className="page-title">Find Donation Centers</h1>
            <p className="page-subtitle">
              Connect with verified centers near you
            </p>
          </Container>
        </div>

        <Container className="content-container">
          {/* Search Bar */}
          <Card className="search-card mb-4">
            <Card.Body>
              <InputGroup size="lg">
                <InputGroup.Text>🔍</InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search by name or location..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button variant="primary" onClick={handleUseMyLocation}>
                  📍 My Location
                </Button>
              </InputGroup>
            </Card.Body>
          </Card>

          {/* Centers Grid */}
          <Row>
            {filteredCenters.map((center) => (
              <Col key={center.id} lg={6} md={6} sm={12} className="mb-4">
                <Card
                  className={`center-card ${selectedCenter?.id === center.id ? "selected" : ""}`}
                  onClick={() => setSelectedCenter(center)}
                >
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div>
                        <h4 className="center-name">{center.name}</h4>
                        <Badge
                          bg={center.isOpen ? "success" : "danger"}
                          className="status-badge"
                        >
                          {center.isOpen ? "● Open" : "● Closed"}
                        </Badge>
                      </div>
                      <Badge bg="info">{center.type}</Badge>
                    </div>

                    <div className="center-info">
                      <p className="info-item">
                        <span className="info-icon">📍</span>
                        {center.address}
                      </p>
                      <p className="info-item">
                        <span className="info-icon">📞</span>
                        {center.phone}
                      </p>
                      <p className="info-item">
                        <span className="info-icon">🚗</span>
                        <strong>{center.distance} km away</strong>
                      </p>
                    </div>

                    <div className="action-buttons">
                      <Button
                        variant="success"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCallNow(center.phone);
                        }}
                      >
                        📞 Call
                      </Button>
                      <Button
                        variant="primary"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleGetDirections(center);
                        }}
                      >
                        🗺️ Directions
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {filteredCenters.length === 0 && (
            <div className="no-results">
              <div className="no-results-icon">🔍</div>
              <h4>No centers found</h4>
              <p>Try different search terms</p>
            </div>
          )}
        </Container>
      </MasterLayout>
    </div>
  );
}

export default FindCenters;
